'use client';

import { useDecisions } from '../../hooks';
import { BranchLegacy } from './Branch.legacy';

export const BranchScript = () => {
    const isOneTrust = useDecisions('onetrust');

    if (isOneTrust) return null;

    return <BranchLegacy />;
};
